import { CloseIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

export interface CardCloseButtonProps {
  onClick: () => void;
}

export const CardCloseButton: React.FC<CardCloseButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <IconButton
      variant="ghost"
      colorScheme="gray"
      aria-label={t("common:close")}
      size="xs"
      icon={<CloseIcon />}
      onClick={onClick}
      minWidth="32px"
      minHeight="32px"
      alignSelf="flex-start"
      position="absolute"
      top="16px"
      right="16px"
    />
  );
};
